module.exports = __webpack_public_path__ + "static/media/matilde-angry.03d58887.png";